import LBox from "@components/LBox";
import LText from "@components/LText";
import { useArtistAccesses } from "@hooks/trpc/useAccesses";
import { useArtistProfileSuspense } from "@hooks/trpc/useArtists";
import { useInteractionReady } from "@hooks/useInteractionReady";
import { theme } from "@theme";
import { useLocalSearchParams } from "expo-router";
import { useEffect } from "react";
import { ActivityIndicator, View } from "react-native";
import AccessListItem from "@components/Accesses/components/AccessListItem";

const Experiences = () => {
  const ready = useInteractionReady();
  const { artistId } = useLocalSearchParams<{
    artistId: string;
  }>();
  const {
    data: artistAccesses,
    hasNextPage,
    fetchNextPage,
    isLoading,
    isFetchingNextPage,
  } = useArtistAccesses([artistId], { enabled: ready });
  const {
    query: { data: artist },
  } = useArtistProfileSuspense(artistId);
  const visibleArtistAccesses = artistAccesses?.filter(
    (access) => access.id !== artist?.pinnedAccess?.id,
  );

  // Eagerly fetch all pages — onEndReached can't fire because
  // this list is nested inside Layout's ScrollView.
  useEffect(() => {
    if (hasNextPage && !isFetchingNextPage) {
      fetchNextPage().catch((error) => {
        console.error("::Experiences:: error fetching next page", error);
      });
    }
  }, [hasNextPage, isFetchingNextPage, fetchNextPage]);

  if (isLoading) {
    return <ActivityIndicator color={theme.colors.white} />;
  }

  if (!visibleArtistAccesses?.length) {
    return (
      <LBox
        flex={1}
        alignSelf="center"
        style={{ width: "70%", paddingTop: "30%" }}
      >
        <LText color="lightGreyText" textAlign="center">
          There are no experiences ongoing currently
        </LText>
      </LBox>
    );
  }

  return (
    <View
      style={{
        paddingHorizontal: theme.spacing.s4,
        paddingTop: theme.spacing.s2,
        rowGap: theme.spacing.s4,
      }}
    >
      {visibleArtistAccesses.map((item) => (
        <AccessListItem key={item.id} access={item} />
      ))}
      {isFetchingNextPage && <ActivityIndicator color={theme.colors.white} />}
    </View>
  );
};

export default Experiences;
